import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 md:flex-row md:items-start" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "relative h-28 w-28" }
const _hoisted_4 = {
  viewBox: "0 0 100 100",
  class: "h-28 w-28 -rotate-90"
}
const _hoisted_5 = ["stroke-dasharray"]
const _hoisted_6 = { class: "absolute inset-0 flex flex-col items-center justify-center" }
const _hoisted_7 = { class: "text-foreground text-2xl font-semibold leading-none" }

import { ContactHealthScoreStats } from '@/types/metrics/ContactHealthScore';
import { getContactHealthScoreStatus } from '@/utils/contactHealthScore';

interface Props {
    healthScore: ContactHealthScoreStats | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactHealthScoreChart',
  props: {
    healthScore: {}
  },
  setup(__props: any) {

const props = __props;
const healthScore = props.healthScore?.score ?? 59;
const circumference = 2 * Math.PI * 42;
const dash = (healthScore / 100) * circumference;

const scoreColor = (score: number) => {
    if (score >= 70) return 'text-success';
    if (score >= 45) return 'text-warning';
    return 'text-danger';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("svg", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("circle", {
            class: "stroke-gray-200",
            cx: "50",
            cy: "50",
            r: "42",
            fill: "none",
            stroke: "var(--border)",
            "stroke-width": "8"
          }, null, -1)),
          _createElementVNode("circle", {
            cx: "50",
            cy: "50",
            r: "42",
            fill: "none",
            class: _normalizeClass(scoreColor(_unref(healthScore))),
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-width": "8",
            "stroke-dasharray": `${dash} ${circumference}`
          }, null, 10, _hoisted_5)
        ])),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(healthScore)), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-muted-foreground mt-1 text-[10px] uppercase tracking-wider" }, " health ", -1))
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", {
          class: _normalizeClass(["text-lg font-semibold", scoreColor(_unref(healthScore))])
        }, _toDisplayString(_ctx.$t(
                            'contact.timeline.stats.healthScore.' +
                                _unref(getContactHealthScoreStatus)(_unref(healthScore)),
                        )), 3)
      ])
    ])
  ]))
}
}

})